import { useState } from "react";
import { postEventCheckin } from "../lib/apiClient";
import { useEvent } from "../contexts/EventContext";

export function useCheckin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const { eventTableKey, eventName } = useEvent(); // いらないこれ？

  const checkin = async ({ encodedSynergyId, historyId, note }) => {
    if (loading) return;
    if (!encodedSynergyId || !eventTableKey || !eventName) return;

    setLoading(true);
    setError(null);
    setDone(false);

    try {
      await postEventCheckin({
        encodedSynergyId,
        eventTableKey,
        eventName,
        historyId,
        note,
      });

      setDone(true);
    }
    catch (e) {
      setError("受付の確定に失敗しました");
    }
    finally {
      setLoading(false);
    }
  };

  return {
    checkin,
    loading,
    error,
    done,
  };
}